:root {
	--ai-fg: #3b3f35;
	--ai-muted: #6b7280;
}

.envHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 12px;
}
.envTitles {
	display: flex;
	flex-direction: column;
	gap: 2px;
}
.envTitle {
	font-size: 14px;
	font-weight: 600;
	color: var(--ai-fg);
	line-height: 1.2;
	margin: 0;
}
.envSubtitle {
	font-size: 12px;
	color: var(--ai-muted);
	line-height: 1.2;
	margin: 0;
}

.switchWrapper {
	--switch-half: 96px;
}

.fieldsGrid {
	display: grid;
	grid-template-columns: repeat(12, minmax(0, 1fr));
	gap: 12px;
}
.col6 {
	grid-column: span 6;
}
.col12 {
	grid-column: span 12;
}
@media (max-width: 640px) {
	.col6,
	.col12 {
		grid-column: span 12;
	}
}

.dbSection {
	margin-top: 16px;
	width: 100%;
	color: #1f2937;
}
.dbList {
	list-style: none;
	padding: 0;
	margin: 0;
	width: 100%;
}

.dbItem {
	display: grid;
	grid-template-areas: "left center right";
	grid-template-columns: 1fr auto auto;
	align-items: center;
	gap: 16px;
	padding: 12px 16px;
	border-bottom: 1px solid #ece7f3;
	background: #ffffff;
}
.dbItem:hover {
	background-color: #fafafa;
}

.rowLeft {
	grid-area: left;
	display: flex;
	align-items: center;
	gap: 12px;
	min-width: 0;
}
.rowCenter {
	grid-area: center;
	display: flex;
	align-items: center;
	gap: 20px;
	justify-content: flex-end;
	flex-wrap: wrap;
}
.rowRight {
	grid-area: right;
	display: flex;
	align-items: center;
	gap: 8px;
	justify-content: flex-end;
}

.dbIcon {
	stroke: #82bc44;
	width: 22px;
	height: 22px;
	flex-shrink: 0;
}
.dbLabels {
	display: flex;
	flex-direction: column;
	min-width: 0;
	overflow: hidden;
}
.dbFilter {
	font-weight: 600;
	font-size: 0.95rem;
	color: #334155;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}

.toggleInline {
	display: flex;
	align-items: center;
	gap: 8px;
}
.toggleText {
	font-size: 12px;
	color: var(--ai-fg);
}
.switchShort {
	--switch-half: 56px;
}

.fileInputHidden {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	border: 0;
}

@media (max-width: 960px) {
	.dbItem {
		grid-template-areas:
			"left"
			"center"
			"right";
		grid-template-columns: 1fr;
		row-gap: 10px;
	}
	.rowLeft {
		align-items: flex-start;
	}
	.dbFilter {
		white-space: normal;
		overflow: visible;
		text-overflow: clip;
	}
	.rowCenter,
	.rowRight {
		justify-content: flex-start;
	}
}

@media (max-width: 640px) {
	.rowCenter {
		gap: 12px;
	}
	.toggleInline {
		gap: 6px;
	}
}
